module.exports = {
	fake_backend: false
}



// WEBPACK FOOTER //
// ./src/environment.js